import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  socialIcons = [
    { name: 'facebook', icon: 'facebook' },
    { name: 'twitter', icon: 'twitter-x' },
    { name: 'linkedin', icon: 'linkedin' }
  ];
}
